/**
 * StatsRow widget -- 3 mini cards: streak, cards due, games played.
 */

import type { Widget, WidgetContext } from '../types';

function getMockStats(): { streak: number; cardsDue: number; gamesPlayed: number } {
  try {
    const raw = localStorage.getItem('aweni_home_stats');
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  return { streak: 7, cardsDue: 12, gamesPlayed: 3 };
}

export const StatsRow: Widget = {
  id: 'stats',
  label: { en: 'Progress Stats', fr: 'Statistiques', ar: 'الإحصائيات', es: 'Estadisticas', de: 'Statistiken' },
  icon: '📊',
  defaultVisible: true,
  defaultOrder: 5,
  defaultSize: 'expanded',

  render(container: HTMLElement, _size: 'compact' | 'expanded', ctx: WidgetContext): void {
    const stats = getMockStats();

    container.innerHTML = `
      <div class="grid grid-cols-3 gap-3">
        <button class="rounded-2xl p-3 text-center transition-transform active:scale-95" style="background:var(--card-bg);box-shadow:var(--shadow-sm);min-height:44px;" data-nav="home">
          <div class="flex items-center justify-center gap-1">
            <span class="${stats.streak > 0 ? 'home-pulse-fire' : ''}" style="font-size:20px;">🔥</span>
            <span class="text-xl font-bold" style="color:#10B981;">${stats.streak}</span>
          </div>
          <p class="text-xs mt-1" style="color:var(--text-secondary);">${ctx.t('home_streak')}</p>
        </button>
        <button class="rounded-2xl p-3 text-center transition-transform active:scale-95" style="background:var(--card-bg);box-shadow:var(--shadow-sm);min-height:44px;" data-nav="memoriz">
          <div class="flex items-center justify-center gap-1">
            <span style="font-size:20px;">${stats.cardsDue === 0 ? '✅' : '📚'}</span>
            <span class="text-xl font-bold" style="color:#F59E0B;">${stats.cardsDue}</span>
          </div>
          <p class="text-xs mt-1" style="color:var(--text-secondary);">${ctx.t('home_cards_due')}</p>
        </button>
        <button class="rounded-2xl p-3 text-center transition-transform active:scale-95" style="background:var(--card-bg);box-shadow:var(--shadow-sm);min-height:44px;" data-nav="games">
          <div class="flex items-center justify-center gap-1">
            <span style="font-size:20px;">🎮</span>
            <span class="text-xl font-bold" style="color:#3B82F6;">${stats.gamesPlayed}</span>
          </div>
          <p class="text-xs mt-1" style="color:var(--text-secondary);">${ctx.t('home_games_played')}</p>
        </button>
      </div>`;

    container.querySelectorAll<HTMLElement>('[data-nav]').forEach((el) => {
      el.addEventListener('click', () => {
        const mod = el.dataset.nav;
        if (mod) ctx.navigate(mod);
      });
    });
  },
};
